"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoUnderwritingRuleFailuresValidation = void 0;
const journey_model_1 = require("@athena-portal/journey-model");
const journey_services_1 = require("@athena-portal/journey-services");
let NoUnderwritingRuleFailuresValidation = class NoUnderwritingRuleFailuresValidation extends journey_services_1.ValidationMethodBase {
    constructor(props, commandsExecutor) {
        super(commandsExecutor);
        this.props = props;
        this.errorMessage = this.props.errorMessage ? this.props.errorMessage : "Sorry, you are not eligible for our cover.";
    }
    validateInput(input, context) {
        const pageContext = context;
        if (pageContext.engine) {
            const interaction = pageContext.engine.getInteraction();
            if (interaction && interaction.underwritingResult && interaction.underwritingResult.length !== 0) {
                if (!this.props || !this.props.underwritingRules || this.props.underwritingRules.length === 0) {
                    return this.invalidResult(this.getErrorMessage(context, this.errorMessage));
                }
                else {
                    const underwritingResultArray = interaction.underwritingResult.map((r) => r.objectName);
                    if (underwritingResultArray.some(r => this.props.underwritingRules.indexOf(r) >= 0)) {
                        return this.invalidResult(this.getErrorMessage(context, this.errorMessage));
                    }
                }
            }
        }
        return this.validResult();
    }
};
exports.NoUnderwritingRuleFailuresValidation = NoUnderwritingRuleFailuresValidation;
exports.NoUnderwritingRuleFailuresValidation = NoUnderwritingRuleFailuresValidation = __decorate([
    (0, journey_model_1.settings)([
        { name: "errorMessage", type: journey_model_1.TypeDescriptions.String },
    ]),
    __metadata("design:paramtypes", [Object, Object])
], NoUnderwritingRuleFailuresValidation);
//# sourceMappingURL=NoUnderwritingRuleFailuresValidation.js.map